<template>
  <div class="py-1">
    <label :for="label" class="block text-sm text-gray-700">{{label}}</label>
    <div class="mt-1 relative rounded-md shadow-sm">
      <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <EnvelopeIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
      </div>
      <input :type="type"  :value="modelValue" @input="updateValue" class="defaultInput pl-10" :placeholder="placeholder" />
    </div>
    <p v-if="error" class="mt-2 text-sm text-rose-600">{{error}}</p>
  </div>
</template>

<script>

import { EnvelopeIcon } from '@heroicons/vue/24/solid'

export default {
    name: 'InputEmail',
    props: {
        type: {
            type: String,
            default: 'text',
        },
        label: String,
        modelValue: String,
        placeholder: String,
        error: String,
    },
    methods: {
        updateValue(event) {
            this.$emit('update:modelValue', event.target.value);
        },
        forLabel() {
            return this.label.replace(/\s/g, '').toLowerCase();
        },
    },    
    components: {
      EnvelopeIcon,
    },
}
</script>